import {
  GridFilterInputValue
} from '@mui/x-data-grid-pro';



/*
    {
      value: "contains",
      getApplyFilterFn: (
        filterItem,
        column
      ) => {
        if (
          !filterItem.columnField ||
          !filterItem.value ||
          !filterItem.operatorValue
        ) {
          return null;
        }

        const filterRegex = new RegExp(filterItem.value, "i");
        return (params) => {
          const rowValue = column.valueGetter
            ? column.valueGetter(params)
            : params.value;
          return filterRegex.test(rowValue?.toString() || "");
        };
      },
      InputComponent: GridFilterInputValue
    },
*/

/*
interface GridTypeFilterInputValueProps extends GridFilterInputValueProps {
    type?: 'text' | 'number' | 'date' | 'datetime-local' | 'singleSelect';
}
declare function GridFilterInputValue(props: GridTypeFilterInputValueProps & TextFieldProps): JSX.Element;

*/
// Default Grid filter operators:
export const filterOperators = {
  'string': [
      // { text: 'grid.filterContainsOperator', operator: 'contains' },
      {
        value: "string_Contains",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'string' }
      },
      // { text: 'grid.filterNotContainsOperator', operator: 'doesnotcontain' },
      {
        value: "string_DoesNotContain",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'string' }
      },
      // { text: 'grid.filterEqOperator', operator: 'eq' },
      {
        value: "string_Equals",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'string' }
      },
      // { text: 'grid.filterNotEqOperator', operator: 'neq' },
      {
        value: "string_DoesNotEqual",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'string' }
      },
      // { text: 'grid.filterStartsWithOperator', operator: 'startswith' },
      {
        value: "string_StartsWith",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'string' }
      },
      // { text: 'grid.filterEndsWithOperator', operator: 'endswith' },
      {
        value: "string_EndsWith",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'string' }
      },     
      // { text: 'grid.filterIsEmptyOperator', operator: 'isempty' },
      {
        value: "string_IsEmpty"
      },
      // { text: 'grid.filterIsNotEmptyOperator', operator: 'isnotempty' }
      {
        value: "string_IsNotEmpty"
      }
  ],

  'number': [
       // { text: 'grid.filterEqOperator', operator: 'eq' },
      {
        value: "number_Equals",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'number' }
      },
      // { text: 'grid.filterNotEqOperator', operator: 'neq' },
      {
        value: "number_DoesNotEqual",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'number' }
      },
      // { text: 'grid.filterGteOperator', operator: 'gte' },
      {
        value: "number_GreaterThanOrEqualTo",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'number' }
      },
      // { text: 'grid.filterGtOperator', operator: 'gt' },
      {
        value: "number_GreaterThan",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'number' }
      },
      // { text: 'grid.filterLteOperator', operator: 'lte' },
      {
        value: "number_LessThanOrEqualTo",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'number' }
      },
      // { text: 'grid.filterLtOperator', operator: 'lt' },
      {
        value: "number_LessThan",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'number' }
      },
      // { text: 'grid.filterIsNullOperator', operator: 'isnull' },
      {
        value: "number_IsEmpty"
      },
      // { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
      {
        value: "number_IsNotEmpty"
      }
  ],

  'dateTime': [
      // { text: 'grid.filterEqOperator', operator: 'eq' },
      {
        value: "dateTime_Equals",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'date' },
      },      
      // { text: 'grid.filterNotEqOperator', operator: 'neq' },
      {       
        value: "dateTime_DoesNotEqual",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'date' },
      },
      // { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
      {
        value: "dateTime_OnOrAfter",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'date' },
      },      
      // { text: 'grid.filterAfterOperator', operator: 'gt' },
      {
        value: "dateTime_After",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'date' },
      },
      // { text: 'grid.filterBeforeOperator', operator: 'lt' },
      {
        value: "dateTime_OnOrBefore",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'date' },
      },
      // { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' },
      {
        value: "dateTime_Before",
        InputComponent: GridFilterInputValue,
        InputComponentProps: { type: 'date' },
      }
      // { text: 'grid.filterIsNullOperator', operator: 'isnull' },
      // { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
  ],

  'singleSelect': [
    // { text: 'grid.filterContainsOperator', operator: 'contains' },
    {
      value: "string_Contains",
      InputComponent: GridFilterInputValue,
      InputComponentProps: { type: 'string' }
    },
    // { text: 'grid.filterNotContainsOperator', operator: 'doesnotcontain' },
    {
      value: "string_DoesNotContain",
      InputComponent: GridFilterInputValue,
      InputComponentProps: { type: 'string' }
    },
    // { text: 'grid.filterEqOperator', operator: 'eq' },
    {
      value: "string_Equals",
      InputComponent: GridFilterInputValue,
      InputComponentProps: { type: 'singleSelect' }
    },
    // { text: 'grid.filterNotEqOperator', operator: 'neq' },
    {
      value: "string_DoesNotEqual",
      InputComponent: GridFilterInputValue,
      InputComponentProps: { type: 'singleSelect' }
    },
    // { text: 'grid.filterStartsWithOperator', operator: 'startswith' },
    {
      value: "string_StartsWith",
      InputComponent: GridFilterInputValue,
      InputComponentProps: { type: 'string' }
    },
    // { text: 'grid.filterEndsWithOperator', operator: 'endswith' },
    {
      value: "string_EndsWith",
      InputComponent: GridFilterInputValue,
      InputComponentProps: { type: 'string' }
    },     
    // { text: 'grid.filterIsEmptyOperator', operator: 'isempty' },
    {
      value: "string_IsEmpty"
    },
    // { text: 'grid.filterIsNotEmptyOperator', operator: 'isnotempty' }
    {
      value: "string_IsNotEmpty"
    }
]
}